import { Link } from "react-router-dom";
import { Linkedin, Mail, ArrowUpRight, Twitter } from "lucide-react";
import { useState, useEffect } from "react";
import axios from "axios";
import { API_BASE_URL } from "../lib/site";

const API = API_BASE_URL;

export default function Footer() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("");
  const [social, setSocial] = useState({ social_linkedin: "https://www.linkedin.com/in/niharika-patel-04b1b4140/", social_twitter: "", social_email: "niharika.patel.9291@gmail.com" });

  useEffect(() => {
    axios.get(`${API}/public/about-content`).then((r) => setSocial(r.data)).catch(() => {});
  }, []);

  const handleSubscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    try {
      await axios.post(`${API}/subscribers`, { email, source: "footer" });
      setStatus("subscribed");
      setEmail("");
    } catch {
      setStatus("error");
    }
  };

  return (
    <footer className="border-t border-[#E5E7EB] bg-white mt-auto" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-12 grid md:grid-cols-3 gap-10">
        {/* Brand */}
        <div>
          <p className="font-['Outfit'] text-lg font-semibold text-[#0A0A0A]">Niharika Patel</p>
          <p className="text-[11px] tracking-[0.18em] uppercase text-[#6B7280] mt-0.5 mb-4">Growth & Marketing Consultant</p>
          <p className="text-sm text-[#4B5563] leading-relaxed max-w-xs">
            Helping B2C startups build integrated growth systems that compound — brand, performance, and CRM as one engine.
          </p>
          <div className="flex gap-3 mt-5">
            {social.social_linkedin && (
              <a href={social.social_linkedin} target="_blank" rel="noreferrer" className="w-9 h-9 border border-[#E5E7EB] flex items-center justify-center text-[#4B5563] hover:border-[#002FA7] hover:text-[#002FA7] transition-colors" aria-label="LinkedIn">
                <Linkedin size={16} />
              </a>
            )}
            {social.social_twitter && (
              <a href={social.social_twitter} target="_blank" rel="noreferrer" className="w-9 h-9 border border-[#E5E7EB] flex items-center justify-center text-[#4B5563] hover:border-[#002FA7] hover:text-[#002FA7] transition-colors" aria-label="Twitter">
                <Twitter size={16} />
              </a>
            )}
            <Link to="/book" className="w-9 h-9 border border-[#E5E7EB] flex items-center justify-center text-[#4B5563] hover:border-[#002FA7] hover:text-[#002FA7] transition-colors" aria-label="Write to me">
                <Mail size={16} />
            </Link>
          </div>
        </div>

        {/* Links */}
        <div>
          <p className="text-[11px] tracking-[0.18em] uppercase font-bold text-[#0A0A0A] mb-5">Explore</p>
          <div className="flex flex-col gap-2">
            {[["Writing", "/writing"], ["Case Studies", "/case-studies"], ["About", "/about"], ["Work With Me", "/book"]].map(([label, href]) => (
              <Link key={href} to={href} className="text-sm text-[#4B5563] hover:text-[#002FA7] transition-colors flex items-center gap-1 group">
                {label} <ArrowUpRight size={12} className="opacity-0 group-hover:opacity-100 transition-opacity" />
              </Link>
            ))}
          </div>
        </div>

        {/* Newsletter */}
        <div>
          <p className="text-[11px] tracking-[0.18em] uppercase font-bold text-[#0A0A0A] mb-3">Newsletter</p>
          <p className="text-sm text-[#4B5563] mb-4 leading-relaxed">
            Marketing insights for B2C founders — no fluff, only frameworks that work.
          </p>
          {status === "subscribed" ? (
            <p className="text-sm text-[#002FA7] font-medium">You're in! Check your inbox.</p>
          ) : (
            <form onSubmit={handleSubscribe} className="flex flex-col gap-2">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="your@email.com"
                className="border border-[#E5E7EB] px-3 py-2.5 text-sm focus:outline-none focus:border-[#002FA7] transition-colors"
                data-testid="footer-email-input"
              />
              <button
                type="submit"
                className="bg-[#002FA7] text-sm font-semibold py-2.5 text-white hover:bg-[#001D66] transition-colors"
                data-testid="footer-subscribe-btn"
              >
                Subscribe
              </button>
              {status === "error" && <p className="text-red-500 text-xs">Something went wrong. Try again.</p>}
            </form>
          )}
        </div>
      </div>

      <div className="border-t border-[#E5E7EB] px-6 lg:px-12 py-4 max-w-7xl mx-auto flex flex-col sm:flex-row justify-between items-center gap-2">
        <p className="text-xs text-[#9CA3AF]">© 2026 Niharika Patel. All rights reserved.</p>
        <Link to="/admin" className="text-xs text-[#D1D5DB] hover:text-[#9CA3AF] transition-colors">Admin</Link>
      </div>
    </footer>
  );
}
